import { z } from "zod";

import { paginationMetaDtoSchema } from "@nasam/kernel";

const id = z.string().min(1);

// A real ISO date-time, not just any string: the list formats it, and an
// unparseable value would crash the render instead of showing the error state.
const isoDateTime = z.string().datetime({ offset: true });

/** One row of `GET /assets/branch-assignments` (NASAM-290), also each item
 *  of `PATCH /assets/branch-assignment`'s response (NASAM-289). */
export const assetAssignmentDtoSchema = z.object({
  id,
  createdAt: isoDateTime,
  asset: z.object({
    id,
    code: z.string(),
    nameEn: z.string(),
    nameAr: z.string(),
  }),
  branch: z.object({
    id,
    nameEn: z.string(),
    nameAr: z.string(),
  }),
});

export const assetAssignmentListResponseDtoSchema = z.object({
  data: z.array(assetAssignmentDtoSchema),
  meta: paginationMetaDtoSchema,
});

/** `PATCH /assets/branch-assignment` body. */
export const assetAssignRequestDtoSchema = z.object({
  branchId: id,
  targetAssets: z.array(id).min(1),
});

export const assetAssignResponseDtoSchema = z.object({
  data: z.array(assetAssignmentDtoSchema),
  message: z.string().optional(),
});

export type AssetAssignmentDto = z.infer<typeof assetAssignmentDtoSchema>;
